<template>
  <div>
    <v-header></v-header>

    <div style="padding-top: 60px;">
      <div class="banner">
        <img src="../../static/img/system_banner_01.png" alt="" />
        <h2 class="item-title">
          <span class="eg" style="color:rgba(255,255,255,1);">为客户提供价值是我们不变的使命</span>
           <span class="ch"> PROVIDING VALUE TO CUSTOMERS IS OUR CONSTANT MISSION </span>
        </h2>
      </div> 
      <div class="class-attendance">
        <h2 class="item-title">
         
          <p class="eg">
             <img src="../../static/img/ju-left.png" alt="" class="leftphoto">
            我们的服务
             <img src="../../static/img/ju-right.png" alt="" class="leftphoto">
            </p> 
          <!-- <span class="ch">班级考勤功能模块</span> -->
         
        </h2>
        <div class="item-pro">
          <dl >
            <dt >
              <img src="../../static/img/fuwu-one.png">
            </dt>
            <dd >
                <p class="title">一对一服务</p>
               <p class="note">定期回访，7×12小时热线技术支持，及时解决您的问题。</p>
            </dd>
          </dl>
        
          <dl >
            
            <dt >
              <img src="../../static/img/fuwu-two.png">
            </dt>
            <dd >
               <p class="title" >部署和调试</p>
               <p class="note">提供经验丰富的工程师上门，为学校提供云平台部署及调试服务。</p>
            </dd>
          </dl>
          <dl >
            <dt >
              <img src="../../static/img/fuwu-three.png">
            </dt>
            <dd >
              <p class="title" >策略指导</p>
               <p class="note">针对学校垂直场景，挖掘客户痛点，专业人员提供针对性专业解决方案与策略。</p>
            </dd>
          </dl>
            <dl >
            <dt >
              <img src="../../static/img/fuwu-four.png">
            </dt>
            <dd >
                <p class="title">培训服务</p>
               <p class="note">提供线上、线下的集中培训，现场提供软件实操训练，提供在线文档资料下载和视频教程观看。</p>
            </dd>
          </dl>
        
          <dl >
            
            <dt >
              <img src="../../static/img/fuwu-five.png">
            </dt>
            <dd >
               <p class="title" >开发服务</p>
               <p class="note">提供专门的项目管理人员与学校相关负责人员对接需求，制定开发任务，保证系统功能匹配开发需求。</p>
            </dd>
          </dl>
          <dl >
            <dt >
              <img src="../../static/img/fuwu-six.png">
            </dt>
            <dd >
              <p class="title" >数据安全</p>
               <p class="note">采用阿里云云计算，保护用户数据安全以及用户隐私。</p>
            </dd>
          </dl>
        </div>
      </div>

      <div class="fuwu-attendance">
        <h2 class="item-title">
         
          <p class="eg">
             <img src="../../static/img/ju-left.png" alt="" class="leftphoto">
            技术支持
             <img src="../../static/img/ju-right.png" alt="" class="leftphoto">
            </p> 
          <!-- <span class="ch">班级考勤功能模块</span> -->
         
        </h2>
        <div class="item-pro">
          <dl >
            <!-- <dt >
             
            </dt> -->
            <dd >
               <img src="../../static/img/fuwu-seven.png">
                <p class="title">售后服务</p>
               <p class="note">及时处理并解决后续学校反馈的线上线下存在问题，为学校提供全方位的服务</p>
            </dd>
          </dl>
        
          <dl >
           
            <!-- <dt >
             
            </dt> -->
             <dd >
                <img src="../../static/img/fuwu-eight.png">
               <p class="title">培训支持</p>
               <p class="note">提供线上、线下培训，现场提供软件实操训练，提供在线文档资料</p>
            </dd>
          </dl>
          <dl >
            <!-- <dt >
             
            </dt> -->
            <dd >
               <img src="../../static/img/fuwu-nine.png">
              <p class="title">客服热线</p>
               <p class="note">学校和家长有疑问可以通过公司客服热线反馈，公司会及时了解情况并提供相应的解决方案</p>
            </dd>
          </dl>
        </div>
      </div>
     
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .header{
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .main{
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    overflow-y: auto
  }

  .footer{
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .text-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .moreline-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2
  }

  .clearfix[data-v-6776eb1c]:after {
    content: "";
    height: 0;
    width: 0;
    display: block;
    clear: both
  }

  .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .item-title .eg{
   font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);

line-height:21px;
  }

  .item-title .ch{
    font-size: 18px;
    font-weight: 700
  }

  .product-introduction{
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px
  }

  .button{
    background: transparent;
    border: 1px solid #ff9a00;
    color: #ff9a00
  }

  .banner{
    width: 100%;
    color: #fff;
    position: relative;
  }
  .banner img{
    width: 100%;
  }

  .banner .item-title{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
    color:rgba(255,255,255,1);
  }
  .banner .item-title .ch{
  width:488px;
height:50px;
font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:33px;
margin-top: 30px;
  }
  .banner .item-title .eg{
   

    width:660px;
height:100px;
line-height: 100px;
background:rgba(255,255,255,0.3);
/* opacity:0.3; */
border-radius:10px;

font-size:40px;
font-family:PingFang SC;
font-weight:400;
/* color:rgba(255,255,255,0.3); */
  }

  .product-system{
    background: #f9f9f9;
    padding: 50px 0;
  }

  .product-system .system-item-pro{
    margin-top: 25px;
    padding: 0 30px;
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
  }
  
.class-attendance{
    padding: 100px 0;
    /* background: #f9f9f9 */
  }

  .class-attendance .item-pro{
    /* padding: 0 10%; */
    width: 90%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-top: 20px;
    margin: 0 auto;
  }

  .class-attendance .item-pro dl{
    width: 100%;
    margin-top: 60px;
    display: flex;
    flex-direction: row;
  }

  .class-attendance .item-pro dt{
    /* width: 100%; */
    display: -ms-flexbox;
    
    -ms-flex-pack: center;
    justify-content: center
  }

  .class-attendance .item-pro dt img{
    width: 100px;
    height: 100px;
  }

  .class-attendance .item-pro dd{
    /* width: 94%; */
    flex: 1;
margin-left: 30px;
  }

  .class-attendance .item-pro dd .title{
 font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
line-height:27px;
  }

  .class-attendance .item-pro dd .note{
    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
margin-top: 30px;
  }
  .leftphoto{
  width: 24px;
  height: 24px;
  margin: 5px 13px;
  display: inline-block;
}

.fuwu-attendance{
    padding: 100px 0;
    background-image: url('~@/../static/img/fuwubg.png');
    background-size: 100% 100%;
  }

  .fuwu-attendance .item-pro{
    width: 90%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-top: 20px;
    margin: 0 auto;
  }

  .fuwu-attendance .item-pro dl{
    width: 100%;
    margin-top: 40px;
    display: flex;
    flex-direction: row;
  }

  .fuwu-attendance .item-pro dt{
    /* width: 100%; */
    display: -ms-flexbox;
    
    -ms-flex-pack: center;
    justify-content: center
  }

  /* .fuwu-attendance .item-pro dt img{
    width: 100px;
    height: 100px
  } */
.fuwu-attendance .item-pro dd img{
    width: 100px;
    height: 100px;
    position: absolute;
    left: -50px;
    top: 60px;
  }
  .fuwu-attendance .item-pro dd{
   padding-left: 100px;
   padding-right: 30px;
    width:640px;
    height:220px;
    background:rgba(255,255,255,1);
    border-radius:10px;
    position: relative;
    margin-left: 40px;
  }

  .fuwu-attendance .item-pro dd .title{
 font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
line-height:27px;
margin-top: 50px;
  }

  .fuwu-attendance .item-pro dd .note{
    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/smarteducational.vue